import { useSelector } from "react-redux";
import type { WalletCreditTransaction } from "@b2bportal/hsbc-wallet-api";
import { creditTransactionsSelector } from "@hsbc/wallet";
import { useCreditsBalance } from "../../../hooks";

interface UseCreditHistorySummaryReturn {
  context: {
    totalCredits: string;
    transactions: Array<WalletCreditTransaction>;
  };
}

export const useCreditHistorySummary = (): UseCreditHistorySummaryReturn => {
  const { totalCredits } = useCreditsBalance();
  const transactions = useSelector(creditTransactionsSelector);

  return {
    context: {
      totalCredits,
      transactions,
    },
  };
};
